import { ID } from 'common/entities/IEntity';
import { Entity, Field } from 'typegraph';

@Entity({one: "product", many: "products"})
export default class Product {

	@Field()
	public id: ID;

	@Field()
	public name: string;

	@Field()
	public subTitle: string;

	@Field()
	public description: string;

	@Field()
	public shortDescription: string;

	@Field()
	public iconURL: string;

	@Field()
	public smallIconURL: string;

}



// WEBPACK FOOTER //
// ./src/panels/featured/entities/Product.ts